import { useEffect } from 'react';
import { useHits } from 'react-instantsearch';

import { useVehicles } from '@/hooks/used-cars/vehicles.hook';

import { getVehicles } from '../actions';

const UsedCarHits = (props: any) => {
  const { setVehicles, setVehiclesMeta, vehiclesMeta } = useVehicles();

  const { results } = useHits(props);

  useEffect(() => {
    if (!results || results.query === '') {
      return;
    }

    setVehiclesMeta({
      ...vehiclesMeta,
      filterCount: results.nbHits,
      currentPage: results.page + 1,
      pageSize: results.hitsPerPage,
      isIndexSearch: true,
    });

    const ids = results.hits.map((hit) => {
      return hit.id;
    });

    // use nextjs action to fetch the directus vehicle data and avoid CORS errors
    if (ids.length > 0) {
      getVehicles(ids).then((vehicles) => {
        setVehicles(vehicles);
      });
    } else {
      setVehicles([]);
    }
  }, [results]);

  return null;
};

export default UsedCarHits;
